import { put } from 'redux-saga/effects';
import { FabricationContractsService } from '../../../services/FabricationContracts';
import { ECustomerTypeView } from '../user/types';
import {
  loadContractsSuccess,
  loadContractsFailure,
  loadContractDetailsSuccess,
  loadContractDetailsFailure,
  loadContractByContractNumberSuccess,
  loadContractByContractNumberFailure
} from './actions';
import { IFabricationContract, Types } from './types';
import { IConstructionData } from '../contracts-and-constructions/types';
import { EToastTypes } from '../toast/types';
import { addToast } from '../toast/actions';

interface ILoadFabricationContractParams {
  payload: {
    customerViewType: ECustomerTypeView;
  };
  type: Types;
}
interface ILoadFabricationContractDetailsParams {
  payload: {
    contractNumber: string;
    customerShipToId: string;
    constructionData: IConstructionData;
  };
  type: Types;
}

export function* loadFabricationContractsSaga(
  params: ILoadFabricationContractParams
) {
  const { customerViewType } = params.payload;
  try {
    const fabricationContractsService = new FabricationContractsService();
    const contracts: IFabricationContract[] =
      yield fabricationContractsService.getContracts(customerViewType);
    yield put(loadContractsSuccess(contracts));
  } catch (err) {
    console.error('loadFabricationContractsSaga', err);
    yield put(
      addToast({
        message: 'Falha ao carregar os contratos.',
        type: EToastTypes.DANGER
      })
    );
    yield put(loadContractsFailure(err));
  }
}

export function* loadFabricationContractsV2Saga() {
  try {
    const fabricationContractsService = new FabricationContractsService();
    const contracts: IFabricationContract[] =
      yield fabricationContractsService.getContractsV2();
    yield put(loadContractsSuccess(contracts));
  } catch (err) {
    console.error('loadFabricationContractsSaga', err);
    yield put(
      addToast({
        message: 'Falha ao carregar os contratos.',
        type: EToastTypes.DANGER
      })
    );
    yield put(loadContractsFailure(err));
  }
}

export function* loadFabricationContractDetailsSaga(
  params: ILoadFabricationContractDetailsParams
) {
  const { contractNumber, customerShipToId, constructionData } = params.payload;
  try {
    const fabricationContractsService = new FabricationContractsService();
    const contractDetails: IFabricationContract =
      yield fabricationContractsService.getContractDetails(
        contractNumber,
        customerShipToId
      );
    yield put(
      loadContractDetailsSuccess(
        contractNumber,
        contractDetails,
        constructionData
      )
    );
  } catch (err) {
    console.error('loadFabricationContractDetailsSaga', err);
    // yield put(addAlertMessage({ message: `Falha ao carregar os detalhes do contrato ${contractNumber}.`, type: EAlertMessageTypes.ERROR }));
    yield put(loadContractDetailsFailure(contractNumber, err));
  }
}

export function* loadFabricationContractDetailsV2Saga(
  params: ILoadFabricationContractDetailsParams
) {
  const { contractNumber, constructionData } = params.payload;
  try {
    const fabricationContractsService = new FabricationContractsService();
    const contractDetails: IFabricationContract =
      yield fabricationContractsService.getContractDetailsV2(contractNumber);
    yield put(
      loadContractDetailsSuccess(
        contractNumber,
        contractDetails,
        constructionData
      )
    );
  } catch (err) {
    console.error('loadFabricationContractDetailsSaga', err);
    // yield put(addAlertMessage({ message: `Falha ao carregar os detalhes do contrato ${contractNumber}.`, type: EAlertMessageTypes.ERROR }));
    yield put(loadContractDetailsFailure(contractNumber, err));
  }
}

export function* loadFabricationContractByContractNumberSaga(
  params: ILoadFabricationContractDetailsParams
) {
  const { contractNumber, customerShipToId } = params.payload;
  try {
    const fabricationContractsService = new FabricationContractsService();
    const contract: IFabricationContract =
      yield fabricationContractsService.getContractDetails(
        contractNumber,
        customerShipToId
      );
    yield put(loadContractByContractNumberSuccess(contract));
  } catch (err) {
    console.error('loadFabricationContractByContractNumberSaga', err);
    yield put(loadContractByContractNumberFailure(err));
  }
}

export function* loadFabricationContractByContractNumberV2Saga(
  params: ILoadFabricationContractDetailsParams
) {
  const { contractNumber } = params.payload;
  try {
    const fabricationContractsService = new FabricationContractsService();
    const contract: IFabricationContract =
      yield fabricationContractsService.getContractDetailsV2(contractNumber);
    yield put(loadContractByContractNumberSuccess(contract));
  } catch (err) {
    console.error('loadFabricationContractByContractNumberSaga', err);
    yield put(loadContractByContractNumberFailure(err));
  }
}
